import { createTable } from "@inmagik/magik-ui"
import { useState } from "react"
import type { FiltersBase, RecordMedia } from "../../types"
import { Link } from "react-router-dom"
import { useDeleteMediaDocument } from "../../hooks/documents"

const Table = createTable<RecordMedia>()

export function TableMedia({
  recordMedia: media,
  setFilters,
  filters,
  refetch,
}: {
  recordMedia: RecordMedia[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  refetch: () => void
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const deleteMediaDocument = useDeleteMediaDocument()

  return (
    <Table
      data={media}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Immagine"
        name="media_file"
        sortable
        width="minmax(max-content, 1fr)"
        render={(media) => (
          <Link to={`/media/media/${media.media_data?.id}`}>
            {media.media_data?.thumbnail ? (
              <img
                src={media.media_data.thumbnail as string}
                alt={media.media_data.title}
                style={{ maxWidth: 100, maxHeight: 100 }}
              />
            ) : (
              "N/A"
            )}
          </Link>
        )}
        stickyLeft
      />

      <Table.Column
        title="Ordine"
        name="order"
        sortable
        width="minmax(max-content, 1fr)"
        render={(media) => <span>{media.order}</span>}
      />

      <Table.Column
        title="Azioni"
        width="minmax(150px, 1fr)"
        render={(media) => (
          <button
            className="btn btn-danger"
            onClick={async () => {
              if (media.id) {
                await deleteMediaDocument.mutateAsync(media.id).then(() => {
                  refetch()
                })
              }
            }}
          >
            Elimina
          </button>
        )}
        stickyRight
      />
    </Table>
  )
}
